var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgManageV(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 6,
    viewBox: "0 0 18 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.66634 2.99984C4.66634 1.80817 3.69134 0.83317 2.49967 0.83317C1.30801 0.83317 0.333008 1.80817 0.333008 2.99984C0.333008 4.1915 1.30801 5.1665 2.49967 5.1665C3.69134 5.1665 4.66634 4.1915 4.66634 2.99984ZM6.83301 2.99984C6.83301 4.1915 7.80801 5.1665 8.99967 5.1665C10.1913 5.1665 11.1663 4.1915 11.1663 2.99984C11.1663 1.80817 10.1913 0.83317 8.99967 0.83317C7.80801 0.83317 6.83301 1.80817 6.83301 2.99984ZM13.333 2.99984C13.333 4.1915 14.308 5.1665 15.4997 5.1665C16.6913 5.1665 17.6663 4.1915 17.6663 2.99984C17.6663 1.80817 16.6913 0.83317 15.4997 0.83317C14.308 0.83317 13.333 1.80817 13.333 2.99984Z",
    fill: "#525559"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageV);
export default __webpack_public_path__ + "static/media/manage_v.8e74bf3bff0e6d1ded84318f85d17ed1.svg";
export { ForwardRef as ReactComponent };